import React from 'react';
import { BsPlus } from 'react-icons/bs';
import { Button, Flex, Icon } from '@chakra-ui/react';
import PropTypes from 'prop-types';

const AddNewButton = ({ icon = BsPlus,
  minWidth = '150px',
  tabName,
  onClick,
  cypressId,
  dataAnalyticsId = undefined,
  isDisabled = false,
  ...rest }) => (
    <Button
      data-analytics-id={dataAnalyticsId}
      data-cy={cypressId}
      dusk={dataAnalyticsId}
      isDisabled={isDisabled}
      minW={minWidth}
      onClick={onClick}
      {...rest}
    >
      <Flex alignItems="center">
        <Icon as={icon} h="21px" mr={2} w="21px" />
        {tabName}
      </Flex>
    </Button>
);

AddNewButton.propTypes = {
  icon: PropTypes.func,
  minWidth: PropTypes.string,
  tabName: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  dataAnalyticsId: PropTypes.string,
  isDisabled: PropTypes.bool,
  cypressId: PropTypes.string
};

export default AddNewButton;
